import { ConditionalTradeCard } from "./conditional-trade-card"

/**
 * Repeat-friendly wrapper around `ConditionalTradeCard`. The Repeat for the conditional
 * trade list iterates over the array and gives this wrapper the current item and index;
 * the wrapper then computes the item-specific callbacks and re-stamps sortOrder so the
 * persisted array is always 0..n-1 in array order.
 *
 * Kept in its own file to comply with CLAUDE.md's "no closure components for Repeat
 * items" rule.
 */
export function ConditionalCardWrapper({ item, index, all, tradeOptions, problemsById, onConditionalsChange }) {
    return (
        <ConditionalTradeCard
            conditional={item}
            tradeOptions={tradeOptions}
            canMoveUp={index > 0}
            canMoveDown={index < all.length - 1}
            problems={problemsById?.get(item.id)}
            onChange={onChange}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            onDelete={onDelete}
        />
    )

    function onChange(updated) {
        const next = all.map(replaceCurrent)
        onConditionalsChange(reSort(next))

        function replaceCurrent(c, i) {
            return i === index ? updated : c
        }
    }

    function onMoveUp() {
        if (index === 0) return
        const next = [...all]
        ;[next[index - 1], next[index]] = [next[index], next[index - 1]]
        onConditionalsChange(reSort(next))
    }

    function onMoveDown() {
        if (index === all.length - 1) return
        const next = [...all]
        ;[next[index], next[index + 1]] = [next[index + 1], next[index]]
        onConditionalsChange(reSort(next))
    }

    function onDelete() {
        const next = all.filter(isNotCurrent)
        onConditionalsChange(reSort(next))
    }

    function isNotCurrent(_, i) {
        return i !== index
    }
}

function reSort(list) {
    return list.map((c, i) => ({ ...c, sortOrder: i }))
}
